import React, { useState,useEffect } from "react";
import Userlist from "./renderlpr2";
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";


const Lprlist = ({
  isOpen,
  header,
  onCancel,onConfirm,
  message,
  list,
  handleClick,
  id,
  typelist,
  size = "xl",
}) => {

  return (
   

      <Modal
        isOpen={isOpen}
        toggle={onCancel}
        size={size}
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <ModalHeader >{header}</ModalHeader>
        <ModalBody>


          {list && list.length > 0 && <Userlist list={list} handleClick ={handleClick}  >  </Userlist>}
        </ModalBody>

        <ModalFooter>
          <Button color="secondary" onClick={onCancel}>
            Close
          </Button>
        </ModalFooter>
      </Modal>
 
  );
};

export default Lprlist;
